export const PHRASE_PROJECT_ID = process.env.PHRASE_PROJECT_ID
export const PHRASE_AUTH_TOKEN = process.env.PHRASE_AUTH_TOKEN

export const PHRASE_CACHE_KEY_PREFIX = 'translations_'

export const LOCALE_MAP: Record<string, string> = {
  en: 'en', zh: 'zh', th: 'th', ru: 'ru', tl: 'tl', id: 'id',
  vi: 'vi', ms: 'ms', hi: 'hi', es: 'es', fr: 'fr', pt: 'pt',
  ar: 'ar', tr: 'tr', my: 'my', ko: 'ko',
}
